import React, { useState, useContext, useEffect } from "react";
import { Button } from "antd";
import "./AddNewLinkRegular.css";
import { PlusOutlined } from "@ant-design/icons";
import { RootContext } from "../../RootContextProvider";

const AddNewLinkRegular = ({
  setModalOpen,
  modalOpen,
  setDisplayBlockPicker,
  setShowUpgradeModal,
}) => {
  const { links, account } = useContext(RootContext);

  const [loading, setLoading] = useState(true);
  const [needUpgrade, setNeedUpgrade] = useState(false);

  useEffect(() => {
    const isAllowedToAddLinks = () => {
      if (account.IsPaying) {
        if (links.length >= 500) {
          setNeedUpgrade(true);
        } else {
          setNeedUpgrade(false);
        }
      } else {
        if (links.length >= 5) {
          setNeedUpgrade(true);
        } else {
          setNeedUpgrade(false);
        }
      }
      setLoading(false);
    };
    isAllowedToAddLinks();
    // eslint-disable-next-line
  }, [links]);

  if (loading) {
    return <></>;
  }
  if (!loading) {
    if (needUpgrade) {
      return (
        <div className="add-new-link-regular">
          <Button
            className="add-link"
            htmlType="submit"
            onClick={() => {
              setShowUpgradeModal(true);
            }}
            icon={<PlusOutlined />}
          >
            Ajouter un bloc
          </Button>
        </div>
      );
    } else {
      return (
        <div className="add-new-link-regular">
          <Button
            className="add-link"
            htmlType="submit"
            onClick={() => {
              setModalOpen(!modalOpen);
              setDisplayBlockPicker(true);
            }}
            icon={<PlusOutlined />}
          >
            Ajouter un bloc
          </Button>
        </div>
      );
    }
  }
};

export default AddNewLinkRegular;
